import React, { useState, useContext, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import appLogo from "../assets/img/app_logo.png";
import ListLeft from "./NavbarComponents/ListLeft";
import ListRight from "./NavbarComponents/ListRight";
import DropdownMenuUser from "./NavbarComponents/DropdownMenuUser";
import { AuthContext } from "../contexts/AuthContext";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import Person from "./Person";
import { socket } from "../services/socket";

export default function Navbar() {
  const [display, setDisplay] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const hasWorkspace = !!currentWorkspace;

  const refreshNotifications = useCallback(() => {
    socket.emit("get_notifications", user.userId);
    socket.emit("get_unread_notification_count", user.userId);
  }, [user.userId]);

  useEffect(() => {
    refreshNotifications();

    socket.on("voici_mes_notifications", (notifs) => {
      setNotifications(notifs);
    });

    socket.on("nombre_notifications_non_lues", (count) => {
      setUnreadCount(count);
    });

    socket.on("insertion_au_groupe", () => {
      refreshNotifications();
    });

    socket.on("membre_removed_from_groupe", () => {
      refreshNotifications();
    });

    socket.on("notification_marquee_lue", (notif) => {
      setNotifications((prev) =>
        prev.map((n) => (n._id === notif._id ? notif : n))
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    });

    socket.on("toutes_notifications_marquees_lues", () => {
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
      setUnreadCount(0);
    });

    socket.on("notification_supprimee", (notifId) => {
      setNotifications((prev) => {
        const removed = prev.find((n) => n._id === notifId);
        if (removed && !removed.read) {
          setUnreadCount((c) => Math.max(0, c - 1));
        }
        return prev.filter((n) => n._id !== notifId);
      });
    });

    return () => {
      socket.off("voici_mes_notifications");
      socket.off("nombre_notifications_non_lues");
      socket.off("insertion_au_groupe");
      socket.off("membre_removed_from_groupe");
      socket.off("notification_marquee_lue");
      socket.off("toutes_notifications_marquees_lues");
      socket.off("notification_supprimee");
    };
  }, [refreshNotifications]);

  return (
    <>
      <nav className="tyn-appbar">
        <div className="tyn-appbar-wrap">
          <div className="tyn-appbar-logo">
            <Link className="tyn-logo taille-du-logo-header" to="/">
              <img src={appLogo} alt="app_logo" className="my-tyn-logo" />
            </Link>
          </div>
          <div className="tyn-appbar-content">
            {hasWorkspace && <ListLeft />}
            <ul className="tyn-appbar-nav tyn-appbar-nav-end ms-auto">
              {hasWorkspace && (
                <>
                  <li className="tyn-appbar-item">
                    <Link
                      to="/workspace/settings"
                      className="tyn-appbar-link"
                      title="Paramètres de l'espace"
                    >
                      <IoSettingsOutline style={{ fontSize: "1.5rem" }} />
                    </Link>
                  </li>
                  <ListRight
                    unreadCount={unreadCount}
                    notifications={notifications}
                  />
                </>
              )}
              <li className="tyn-appbar-item">
                <button
                  className="d-inline-flex btn dropdown-toggle btn-dropdown-menu-user"
                  data-bs-auto-close="outside"
                  data-bs-toggle="dropdown"
                  disabled={display}
                  onClick={() => setDisplay(!display)}
                  data-bs-offset="0,10"
                >
                  <div className="tyn-media tyn-size-lg tyn-circle">
                    <Person
                      person={{
                        image: user.userImage,
                        nom: user.nom,
                        prenom: user.prenom,
                        colors: user.color,
                        userId: user.userId,
                      }}
                    />
                  </div>
                </button>
                <DropdownMenuUser display={display} setDisplay={setDisplay} />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
